import { useEffect, useRef } from "react";
import { mix } from "polished";

// Event listener function that gets the x and y coordinates of the mouse cursor
// and sets them as CSS variables on the children elements of the element the event is fired from

function onMouseMove(e) {
  for (const child of e.currentTarget.children) {
    const rect = child.getBoundingClientRect(),
      x = e.clientX - rect.left,
      y = e.clientY - rect.top,
      start = getComputedStyle(child).getPropertyValue("--button-glow-start").trim(),
      end = getComputedStyle(child).getPropertyValue("--button-glow-end").trim()
      ;
      
    // mix = mix(x/rect.width, start, end);
    child.style.setProperty("--mouse-x", `${x}px`);
    child.style.setProperty("--mouse-y", `${y}px`);

    if (child.classList.contains("button-glow")) {
      child.style.setProperty("--button-glow", `${mix(x/rect.width, start, end)}`);
    }
  }
    // child.style.setProperty("--button-glow", `${mix(x/rect.width, start, end)}`);

}


// A custom hook that allows for adding a mousemove event listener to an element

export function useHoverEffect() {
  // A ref to hold the reference of the element the hook is called on
  const ref = useRef();

  // Adding event listener when component mounts and removing it when component unmounts
  useEffect(() => {
    const el = ref.current;
    // If the element is not found, return early

    if (!el) return;

    // Attaching the event listener to the element
    el.addEventListener("mousemove", onMouseMove);

    // Removing the event listener when component unmounts
    return () => {
      el.removeEventListener("mousemove", onMouseMove);
    };
  }, [ref]); // Re-render only when ref changes

  return ref;
}
